const __WEBPACK_NAMESPACE_OBJECT__ = lvflanders.bar.ng.agGrid;